import Component from '@glimmer/component';

export default class EditLineItemSelectedContactComponent extends Component {
  <template>
    <span>{{@option.name}}</span>
  </template>
}
